import { createContext, useContext, useEffect } from 'react';

/**
 * Lets the kiosk idle timer (in the shell, above the page) know whether the
 * concierge page is actually rendered. The idle warning then follows the page
 * itself, not a live LD read that can disagree with the page's latched gate.
 */
export const ConciergeHostPresenceContext = createContext<(isMounted: boolean) => void>(() => undefined);

export function useRegisterConciergeHostPresence(): void {
  const setIsMounted = useContext(ConciergeHostPresenceContext);
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, [setIsMounted]);
}
